import _slicedToArray from "/home/jenkins/workspace/Sadashboard-build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useEffect, useState } from 'react';

var useClipboard = function useClipboard() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$updateFrequency = _ref.updateFrequency,
      updateFrequency = _ref$updateFrequency === void 0 ? 1000 : _ref$updateFrequency;

  var onReadError = arguments.length > 1 ? arguments[1] : undefined;

  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      clipboard = _useState2[0],
      setClipboardContent = _useState2[1];

  var copyToClipboard = function copyToClipboard(clipboardContent, onCopyToClipboard, onWriteError) {
    if (navigator.permissions && navigator.clipboard) {
      navigator.permissions.query({
        name: 'clipboard-write'
      }).then(function (_ref2) {
        var state = _ref2.state;

        if (['granted', 'prompt'].includes(state)) {
          navigator.clipboard.writeText(clipboardContent).then(function () {
            setClipboardContent(clipboardContent);
            onCopyToClipboard(clipboardContent);
          }, onWriteError || function () {});
        } else {
          onWriteError({
            message: 'ClipboardWrite permission has been blocked as the user.'
          });
        }
      });
    }
  };

  useEffect(function () {
    var readClipboardInterval;

    if (navigator.permissions && navigator.clipboard) {
      navigator.permissions.query({
        name: 'clipboard-read'
      }).then(function (_ref3) {
        var state = _ref3.state;

        if (['granted', 'prompt'].includes(state)) {
          readClipboardInterval = setInterval(function () {
            navigator.clipboard.readText().then(function (clipboardContent) {
              setClipboardContent(clipboardContent);
            }, onReadError || function () {});
          }, updateFrequency);
        } else {
          onReadError({
            message: 'ClipboardRead permission has been blocked as the user.'
          });
        }
      });
    }

    return function () {
      if (navigator.clipboard) {
        clearInterval(readClipboardInterval);
      }
    };
  }, []);
  return [clipboard, copyToClipboard];
};

export default useClipboard;